var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdm-stripe',{attrs:{"text":_vm.$t('school'),"size":_vm.size,"color":"#A70074"}})}
var staticRenderFns = []

export { render, staticRenderFns }